export default "__VITE_ASSET__2svQAXBp__"